import { render, staticRenderFns } from "./NaturalAdventures.vue?vue&type=template&id=4f11d3b8&"
import script from "./NaturalAdventures.vue?vue&type=script&lang=js&"
export * from "./NaturalAdventures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports